import React from "react";
import { Option, ListDivider, Typography } from "@mui/joy";
import { useTranslation } from 'react-i18next';

export const useSelectOptions = () => {
    const { t } = useTranslation();

    const createStructureFromPlainList = (list) => {
        return list.map((option) => createStructureFromString(option))
    }

    const createStructureFromString = (option) => {
        return { "label": option.replace('_related_', '').replace('_readable', '').replace('_numeric', ''), "value": option, "group": (option.replace('_readable', '').replace('_numeric', '').split('_')[2] ?? 'default') }
    }

    const getSelectOptions = (optionlist, translateOptions = true) => {
        const groupedOptions = {};

        optionlist.forEach(option => {
            if (typeof option === 'string') {
                option = createStructureFromString(option)
            }

            const group = option.group || 'default';
            if (!groupedOptions[group]) {
                groupedOptions[group] = [];
            }
            groupedOptions[group].push(option);
        });

        return Object.entries(groupedOptions).map(([groupName, options]) => {
            const isDefaultGroup = groupName === 'default';

            return (
                <React.Fragment key={groupName}>
                    {!isDefaultGroup && (
                        <ListDivider>
                            <Typography level="body-sm" fontWeight="lg">
                                {translateOptions ? t(groupName) : groupName}
                            </Typography>
                        </ListDivider>
                    )}
                    {options.map((option, k) => (
                        <Option key={k} value={option.value}>
                            {translateOptions ? t(option.label) : option.label}
                        </Option>
                    ))}
                </React.Fragment>
            );
        });
    }

    return {
        getSelectOptions,
        createStructureFromPlainList
    }
};
